import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
    name: 'arrayfilter'
})

@Injectable()
export class ArrayFilterPipe implements PipeTransform {

    transform(items: any[], field: string, value: string): any[] {
        if (!items) {
            return [];
        }
        if (field.toString().trim().length === 0) {
            return items.filter(it => {
                return it ? it.PortfolioNameId ? it.PortfolioNameId === value : false : false;
            });
        }
        else {
            return items.filter(singleItem => singleItem[field] === (value));
        }
    }
}